// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Drawer_overlay__diiFY","drawer":"Drawer_drawer__Qjbik","slide-in":"Drawer_slide-in__tjZj1","slide-out":"Drawer_slide-out__y9Irf","closeBtn":"Drawer_closeBtn__YYp_j"};